<template>
  <div
    class="sidebar"
    :style="{ 
      '--sidebar-width': sidebarWidth,
      '--margin-top': isTotemAccessibility ? messageHeight : marginTop,
      '--margin-bottom': isTotemAccessibility ? '400px' : marginBottom
    }"
  >
    <texto-menu-activo />
    <table class="sidebar-menu" v-if="menus">
      <tr
        v-for="(item, index) in menus"
        :key="index"
      >
        <td>
          <sidebar-item
            :data="item"
            :index="index"
          />
        </td>
      </tr>
    </table>
    <br /><br />
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
import constants from '@/constants'
import TextoMenuActivo from './TextoMenuActivo'
import SidebarItem from './SidebarItem'
export default {
  components: {
    TextoMenuActivo,
    SidebarItem
  },
  computed: {
    ...mapState('app',['isTotemAccessibility']),
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    marginTopAccessibility() {
      return constants.totem.textoMenuActivo.height + 'px'
    },
    marginTop() {
      return (constants.totem.meteo.height + constants.totem.messages.height) + 'px'
    },
    marginBottom() {
      return constants.totem.accessibility.height + 'px'
    },
    messageHeight() {
      return constants.totem.messages.height + 'px'
    }
  },
  data () {
    return {
      menus: null
    }
  },
  mounted () {
    api.getAll(`menus/totem`, false, null, null, null, utils.getDomain()).then(response => {
      this.menus = response
    })
  }
}
</script>

<style scoped>
  .sidebar {
    position: fixed;
    top: var(--margin-top);
    bottom: var(--margin-bottom);
    /* background-color: #00000080; */
    width: var(--sidebar-width);
    overflow-x: scroll;
  }
  .sidebar-menu {
    width: var(--sidebar-width);
  }
</style>
